import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { useCreateEditorContext } from "./hooks/useCreateEditorContext.js";
const editorAPIContext = createContext(void 0);
const editorDataContext = createContext(void 0);
function EditorContext(props) {
  const { children, ...rest } = props;
  const { api, data } = useCreateEditorContext(rest);
  return /* @__PURE__ */ jsx(editorAPIContext.Provider, { value: api, children: /* @__PURE__ */ jsx(editorDataContext.Provider, { value: data, children }) });
}
export {
  EditorContext,
  editorAPIContext,
  editorDataContext
};
//# sourceMappingURL=EditorContext.js.map
